import c3 from 'c3';
import 'c3/c3.min.css';
import * as d3 from 'd3';
// import D3Funnel from 'd3-funnel/dist/d3-funnel.js';
import "./styles.css";
import useStyles from "./styles";
import { useSelector } from "react-redux";
import React, { useState, useEffect } from 'react';
import { Typography } from '@material-ui/core';
import GeoChart from '../GeoChart';
import { pathOr } from "ramda";
import { getCalculations } from '../../../../../../common/policyCalculation';
import SkeletonShell from "../../../../../Skeleton/index";

const CustomDashletGroupChartXirr = ({ data, fullData, value, result = [], showXirrVersion,isDashletUpdated=[],allTabFilter=[] }) => {
	const { currentTheme } = useSelector((state) => state.config.themeConfig);
    let chartView = pathOr('yearly', [pathOr('', ['filter',1], data),pathOr('', ['filter',2], data)], allTabFilter);
    chartView = chartView == ''?'yearly':chartView;

    const getData = pathOr([], ['sameResponseTo', 'data', 'data'], fullData);
    let getChartData = [];
    let maxBar = 0;
    let yearValue = [];

    // COde is comment by deep as we have to show only one from yearly or cagr.
    /*
    getData.forEach(element => {
        for(let i in element) {
            if(pathOr(false, [i, 'chart_data'], element)){
                // getChartData.push(pathOr([], [i, 'chart_data'], element));
                let getKey = Object.keys(pathOr([], [i, 'chart_data'], element));
                getKey = getKey[0];
                let tempCagrData =  pathOr({}, [i, 'chart_data', getKey, 'cagr'], element);
                let tempYearlyData =  pathOr({}, [i, 'chart_data', getKey, 'yearly'], element);
                getChartData[getKey] = {'cagr': tempCagrData, 'yearly': tempYearlyData};
                let length = Object.keys(tempYearlyData).length;
                maxBar = maxBar <  length ? length : maxBar;
            }
            
        }
    });

    let yearKeyValue = [];
    for(let i=maxBar-1; i>=0; i--){
        yearKeyValue[i] =  maxBar-i;
    }
    const xAxisLableValue = [ 'x', ...yearKeyValue ]; // x-axis values
    console.log(xAxisLableValue);
    let getChartFinalData = [];
    let listOfLineChart = {};
    let lineChartAxis = {};
    getChartFinalData.push(xAxisLableValue);
    let getKeyData = Object.entries(getChartData);
    getKeyData.map(([keyCode, dataSet ]) => {
        let cagrRow = [];
        let yearlyRow = [];
        for(let i=1; i<= maxBar; i++){
            cagrRow[maxBar-i] = dataSet.cagr[i] !== undefined ? getCalculations('convertIntoPercentWithoutSign', dataSet.cagr[i]) : 0;
            yearlyRow[maxBar-i] = dataSet.yearly[i] !== undefined ? getCalculations('convertIntoPercentWithoutSign', dataSet.yearly[i]) : 0;
        }
        listOfLineChart[keyCode+' Ave. Annual Return'] = 'line';
        lineChartAxis[keyCode+' Ave. Annual Return'] = 'y2';
        getChartFinalData.push([keyCode+' Yearly Return', ...yearlyRow]);
        getChartFinalData.push([keyCode+' Ave. Annual Return', ...cagrRow]);
    }); 
    */

    // Code started for either yearly or cagr
    getData.forEach(element => {
        for(let i in element) {
            if(pathOr(false, [i, 'chart_data'], element)){
                // getChartData.push(pathOr([], [i, 'chart_data'], element));
                let getKey = Object.keys(pathOr([], [i, 'chart_data'], element));
                getKey = getKey[0];
                let tempData =  pathOr({}, [i, 'chart_data', getKey, chartView], element);
                getChartData[getKey] = {[chartView]: tempData};
                let length = Object.keys(tempData).length;
                maxBar = maxBar <  length ? length : maxBar;
                yearValue = [...yearValue, ...Object.keys(tempData)];
            }
            
        }
    });
    
    yearValue = [...new Set(yearValue.sort())];
    const xAxisLableValue = [ 'x', ...yearValue ]; // x-axis values
    const yAxisLable = chartView == 'cagr'? 'Average Annual Return': 'Year on Year Return';
    let chartTitle = chartView == 'cagr'? 'Average Annual Return': 'Year on Year Return';
    let getChartFinalData = [];
    let getKeyData = Object.entries(getChartData);
    getChartFinalData.push(xAxisLableValue);
    getKeyData.map(([keyCode, dataSet ]) => {
        let Row = [];
        for(let i=0; i<yearValue.length; i++){
            Row[i] = dataSet[chartView][yearValue[i]] !== undefined ? getCalculations('convertIntoPercentWithoutSign', dataSet[chartView][yearValue[i]]) : 0;
        }
        let legentName = keyCode;
        getChartFinalData.push([legentName, ...Row]);
    }); 
	const [dashId, setDashId] = useState(pathOr('', ['id'], fullData));

	const [showLoading,setShowLoading]= useState(isDashletUpdated.includes(dashId));
	const {  configureDashletLoading } = useSelector(
		(state) => state.dashboard,
	  );

	const makeid=()=> {
		var text = "";
		var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
	  
		for (var i = 0; i < 5; i++)
		  text += possible.charAt(Math.floor(Math.random() * possible.length));
	  
		return text;
	  }
	const callbackMethod = pathOr('', ['data', 'callbackMethod'], data);

	const classes = useStyles();
	let chartJson = [];
	const min = 1;
    const max = 100;
    const rand = min + Math.random() * (max - min);
	let chartNewName = Math.random();
	let chartName = data.name;

	switch (data.type) {
		case 'xirr_group':

			//Calculate Ratio of chart
			let ratio = 0.1;
			if(maxBar <= 2){
				ratio = 0.05;
			}else if(maxBar > 2 && maxBar <=5){
				ratio = 0.15;
			}else if(maxBar >=5 && maxBar < 8){
				ratio = 0.3;
			}else if(maxBar >=8 && maxBar < 12){
				ratio = 0.7;
			}else if(maxBar >=12){
				ratio = 0.1;
			}
			chartJson = {
				padding: {
					right: 20,
					bottom: 20,
				},
				bindto: '#' + chartName,
				data: {
					x: 'x',
					columns: [
						...getChartFinalData
					],
					// axes: lineChartAxis,
					type: 'bar',
					// types: listOfLineChart,

					empty: { label: { text: "No Data" } },

				},
				title: {
					text: chartTitle,
				},
				padding: {
					right: 80
				},				  
				subchart: {
					show: true
				},
				grid: {
					y: {
						lines: [{ value: 0 }]
					}
				},
				bar: {
					width: {
						ratio: ratio // this makes bar width 50% of length between ticks
					}
				}, axis: {
					x: {
						
						extent: [2, 4],
						type: 'category',
						tick: {
							rotate: 30,
							multiline: false,
						},
						// height: 130
					},
					y2: {
						show: false,
						tick: {
							format: function (d) {
								return (parseInt(d) == d) ? d.toFixed(2)+'%' : d.toFixed(2)+'%';
							}
						},
						label: {
							text: 'Year on Year Return',
							position: 'outer-middle'
						}
					},
					range: { max: 100, min: -100 },
					y: {
						label: {
							text: yAxisLable,
							position: 'outer-middle'
							// inner-right : default
							// inner-center
							// inner-left
							// outer-right
							// outer-center
							// outer-left
						},
						tick: {
							format: function (d) {
								return (parseInt(d) == d) ? d.toFixed(2)+'%' : d.toFixed(2)+'%';
							}
						}
					}
				}


			};
			break;
		default:
			chartJson = {};

	}

	React.useEffect(() => {
				 c3.generate(chartJson);
		}, [chartJson]);
	return (
		<div className={currentTheme === 'dark' ? "inverted" : null}>

			{
				 (configureDashletLoading && !isDashletUpdated.length) || (showLoading) ? <SkeletonShell layout={data.type==='pie'?"chartRound":"chartRectangle"} /> : <div key={chartName} style={{height:360}} className={classes.chartBox} id={chartName}>
					<Typography align="center"><i className={" fas fa-7x fa-exclamation-triangle " + classes.noData}></i></Typography>
					<Typography align="center" color="textSecondary">No Data</Typography>
				</div>}
		</div>
	);

}
export default React.memo(CustomDashletGroupChartXirr);